import type React from 'react';

import { Spinner, Text } from '@change/ds-core-ui';

import { ClientRender } from '@change-corgi/core/react/ssr/render';

import { TeamMemberCard } from './components/TeamMemberCard';
import type { Group } from './hooks/useTeamMembers';
import { useTeamMembers } from './hooks/useTeamMembers';

export const TeamMembers: React.FC = () => {
	const {
		data: { groups },
	} = useTeamMembers();

	return (
		<div className="pb-16">
			{groups.map((group) => (
				<section key={group.name}>
					<Text as="h2" size="small" variant="heading" className="mt-12 text-center">
						{group.name}
					</Text>
					{
						// to optimize server-rendering, we avoid rendering the full list server-side
						group.clientRenderOnly ? (
							<ClientRender placeholder={<Spinner className="mx-auto my-64" />}>
								<TeamMembersGroupItems group={group} />
							</ClientRender>
						) : (
							<TeamMembersGroupItems group={group} />
						)
					}
				</section>
			))}
		</div>
	);
};

const TeamMembersGroupItems: React.FC<{ group: Group }> = ({ group }) => {
	return (
		<ul className="row-gap-8 grid grid-cols-2 gap-x-2 gap-y-8 pt-6 pb-6 md:grid-cols-4 xl:grid-cols-5">
			{group.items.map((member) => (
				<TeamMemberCard member={member} key={member.id} />
			))}
		</ul>
	);
};
